/* tacosarebetter — theme.js
 * Vanilla JS only. No frameworks. No jQuery.
 * Boots after DOMContentLoaded. Each module is a small, focused init.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---- Mobile nav drawer ----------------------------------------- */
  function initMobileNav() {
    const drawer = document.querySelector('[data-mobile-nav]');
    const open = document.querySelector('[data-nav-open]');
    const close = document.querySelector('[data-nav-close]');
    if (!drawer || !open) return;

    function setOpen(state) {
      drawer.classList.toggle('is-open', state);
      drawer.setAttribute('aria-hidden', state ? 'false' : 'true');
      document.documentElement.style.overflow = state ? 'hidden' : '';
    }

    open.addEventListener('click', () => setOpen(true));
    if (close) close.addEventListener('click', () => setOpen(false));
    drawer.addEventListener('click', (e) => {
      if (e.target.matches('a')) setOpen(false);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* ---- Quantity steppers ----------------------------------------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach((wrap) => {
      const input = wrap.querySelector('input[type="number"]');
      if (!input) return;
      wrap.querySelectorAll('[data-qty-step]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
          const current = parseInt(input.value, 10) || 1;
          const next = Math.max(parseInt(input.min || '1', 10), current + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---- Variant chip selection ----------------------------------- */
  function initVariantChips() {
    const chips = document.querySelectorAll('.variant-chip input[type="radio"]');
    chips.forEach((input) => {
      input.addEventListener('change', () => {
        document.querySelectorAll('.variant-chip').forEach((chip) => {
          const inner = chip.querySelector('input');
          chip.classList.toggle('is-selected', inner && inner.checked);
        });
      });
    });
  }

  /* ---- Cart count refresh after add (uses /cart.js Ajax API) ---- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then((r) => r.ok ? r.json() : null)
      .then((cart) => {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          // brief scoreboard-flip on update
          el.classList.remove('flip__inner');
          // force reflow for re-trigger
          void el.offsetWidth;
          el.classList.add('flip__inner');
        });
      })
      .catch(() => {});
  }

  /* ---- Add-to-cart Ajax with scoreboard-flip confirmation ------- */
  function initAddToCart() {
    document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        // Allow native submit if JS is being weird; only intercept when fetch is supported.
        if (!window.fetch) return;
        e.preventDefault();
        const btn = form.querySelector('[data-add-to-cart]');
        const original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }

        const data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
          .then((r) => r.json())
          .then(() => {
            if (btn) {
              btn.classList.remove('flip__inner');
              void btn.offsetWidth;
              btn.classList.add('flip__inner');
              btn.textContent = 'On the card';
              setTimeout(() => {
                btn.textContent = original || 'Add to cart';
                btn.disabled = false;
              }, 1400);
            }
            refreshCartCount();
          })
          .catch(() => {
            if (btn) { btn.disabled = false; btn.textContent = original; }
            form.submit();
          });
      });
    });
  }

  /* ---- Delegated action handlers (data-action="...") ------------ */
  function initActions() {
    document.addEventListener('click', (e) => {
      const target = e.target.closest('[data-action]');
      if (!target) return;
      const action = target.getAttribute('data-action');
      if (action === 'print') {
        e.preventDefault();
        window.print();
      }
    });
  }

  /* ---- Boot ------------------------------------------------------ */
  ready(function () {
    initMobileNav();
    initQty();
    initVariantChips();
    initAddToCart();
    initActions();
  });
})();
